define('responsive-gameday/views/render/PregameViewRender',['require','exports','module','./ViewRender','Wax/get!view-templates/pregame/pregame','Wax/get!view-templates/linescore/embeddedLinescore','Wax/get!view-templates/pregame/lineup','Wax/get!view-templates/pregame/matchupTeam'],function(require,exports,module){
    var ViewRender = require('./ViewRender'),
        Superclass;

    function PregameViewRender(){
        Superclass.constructor.call(this,
            require('Wax/get!view-templates/pregame/pregame'),{
                embeddedLinescoreView   : require( 'Wax/get!view-templates/linescore/embeddedLinescore' ),
                lineupView              : require( 'Wax/get!view-templates/pregame/lineup' ),
                matchupTeamView         : require( 'Wax/get!view-templates/pregame/matchupTeam' )
            }
        );
    }
    ViewRender.spawn(PregameViewRender).define({
        toggleStatcastDefinitions : function(activeStatType) {
            var statcastDefs = $('.definitions');
            if(activeStatType){
                statcastDefs.show();
            } else {
                statcastDefs.hide();
            }
        },
        handleMatchupToggle : function(content, activeViewType) {
            var $statToggles = $('.sub');
            if(activeViewType) {
                $statToggles.hide();
                content.setAttribute('data-stat-type', this.viewState.activeStatType = 0);
                this.toggleStatcastDefinitions(0);
            } else {
                $statToggles.show();
            }
        }
    });

    Superclass=PregameViewRender.superclass;

    return PregameViewRender;
});
